module.exports = __webpack_public_path__ + "static/img/321.ac2267ee.jpeg";